import { CB_59_GROWTH_AT_TRIAL_SIGNUP } from '@disco/constants/FeatureTypes'
import {
  getConstanceSetting,
  getUser,
} from '@disco/state-management/selectors/user'
import { isTrialExpired } from '@disco/utils/trial'

import type { State } from 'types/redux'

/** Whether Billing shows Chargebee signup for a running Business or Artist trial. */
export const showsTrialSignup = (state: State): boolean => {
  const user = getUser(state)
  return (
    Boolean(getConstanceSetting(state, CB_59_GROWTH_AT_TRIAL_SIGNUP)) &&
    user.business?.private_metadata?.plan_type === 'trial' &&
    !isTrialExpired(user)
  )
}
